export const isAdminPath = (path = '') => (
  path === '/admin' ||
  path.startsWith('/admin/patients') ||
  path.startsWith('/admin/token-usage') ||
  path.startsWith('/doctors') ||
  path.startsWith('/clinics') ||
  path.startsWith('/health-house-stations') ||
  path.startsWith('/health-house-connectors') ||
  path.startsWith('/admin/debug-demo')
);

export const isDoctorPath = (path = '') => (
  path === '/doctor' ||
  path.startsWith('/realtime-consultations') ||
  path.startsWith('/reports') ||
  path.startsWith('/reviewed-reports') ||
  path.startsWith('/appointment-orders') ||
  path.startsWith('/patients') ||
  path.startsWith('/user-center')
);

export const getActiveWorkspace = (path = '') => {
  if (isAdminPath(path)) {
    return 'admin';
  }

  if (isDoctorPath(path)) {
    return 'doctor';
  }

  return 'home';
};
